export enum MonitoringTabTypes {
    LAS = 'las',
    EFICIENCY = 'efficiency',
    MOMENT_AND_WEIGHT = 'moment-weight',
    DRM = 'drm',
    PRO_MASTER = 'pro-master',
    CANDLE_CONSTRUCTION = 'candle-construction',
    DD_CONTROL = 'dd-control',
    SLIDE_SHEET = 'slide-sheet',
}

export const MonitoringTabLabels = {
    MONITORING: 'monitoring',
    LAS: 'lasTab.las',
    EFICIENCY: 'crewEfficiencyTab.efficiency',
    MOMENT_AND_WEIGHT: 'momentAndWeightCharTab.momentAndWeight',
    DRM: 'rtkTab.drm',
    PRO_MASTER: 'digitalDrillingTab.proMaster',
    CANDLE_CONSTRUCTION: 'candleConstruction.candleConstruction',
    DD_CONTROL: 'ddControlTab.ddControl',
    SLIDE_SHEET: 'slideSheet',
};
